<!--
 * @Description: 网上服务大厅
 * @Author: PF
 * @Date: 2023-12-04 13:52:33
 * @LastEditors: PF
 * @LastEditTime: 2026-09-11 14:00:44
-->
<template>
  <div class="fuwudating_page html_dark">
    <el-scrollbar height="100%" always :min-size="30">
      <!-- 头部 -->
      <div class="banner" style="padding: 10px;">
        <div style="width: 100%;display: flex;justify-content: space-between;align-items: center;">
          <!-- <div style="width: 300px;text-align: center;">
            <p style="font-size: 2em;color: #fff;font-weight: 500;margin-bottom: 10px;width: max-content;text-shadow: 1px 1px 5px #fff;">网上服务大厅</p>
            <p>“一站式”为您汇集</p>
          </div>
          <el-image style="width: 80%;height: 100%;" src="/fuwudating/banner-img.png" fit="contain" />
        </div> -->
          <div style="width: calc(100% - 440px); margin-right:10px;">
            <el-carousel>
              <el-carousel-item v-for="(item, index) in lbtData" :key="index">
                <a v-if="item.ljdz" :href="item.ljdz" target="_blank">
                  <tupian :img="item.tpurl" :col="'#fff'" />
                </a>
                <tupian v-else :img="item.tpurl" :col="'#fff'" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="hp100">
            <div class="tongzhigonggao">
              <div class="tit tzgg-tit">
                <div class="tzgg-head">
                  <!-- 标题 -->
                  <div class="tzgg-head__title">
                    <span class="tzgg-head__bar"></span>
                    <span class="tzgg-head__text">通知公告</span>
                  </div>
                  <!-- 分类切换：玻璃胶囊分段控件（滑块随选中项平滑滑动） -->
                  <div class="tzgg-tabs" :style="{ '--thumb-index': GongGaoActive }">
                    <span class="tzgg-tabs__thumb"></span>
                    <span
                      v-for="(tab, index) in tzggTabs"
                      :key="tab.value"
                      class="tzgg-tabs__item"
                      :class="{ 'is-active': GongGaoActive === index }"
                      @click="GongGaoActive = index; initTongZhiGongGao()"
                    >{{ tab.label }}</span>
                  </div>
                  <!-- 更多：圆形玻璃图标按钮 -->
                  <el-tooltip content="更多公告" placement="top" :show-after="300">
                    <button class="tzgg-more" type="button" aria-label="更多公告" @click="isTZGGGD = true">
                      <el-icon><Memo /></el-icon>
                    </button>
                  </el-tooltip>
                </div>
                <div class="xian"></div>
              </div>
              <ul class="tongzhi h190" v-loading="tzggLading" element-loading-background="rgba(255, 255, 255, 0)">
                <li v-for="(item, index) in tzggData" :key="index">
                  <div class="beyond-hidden-single" style="cursor: pointer;width: calc(100% - 100px);" @click="isTZGGSEE=true;row=item">[{{item.jgmc}}] {{ item.bt }}</div>
                  <div class="w90" style="text-align: right;">{{ item.fbsj }}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- 待办工作 -->

      <div class="gognzuorenwu ml10 mr10">
        <div class="schedule wp100">
          <div style="display: flex;justify-content: space-between;align-items: center;">
            <div class="tit pl0 pr0 w150">
              <span>工作任务</span>
              <div class="xian"></div>
            </div>
            <!-- 搜索 -->
            <el-form class="mb0" :model="dbParms" style="display: flex;" @submit.enter.prevent>
              <el-form-item style="width: 220px;margin: 10px 10px 10px 0;">
                <el-date-picker v-model="dbRqqj" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" value-format="YYYY-MM-DD" @change="initDaiBan()" />
              </el-form-item>
              <el-form-item style="width: 200px;margin: 10px 10px 10px 0;">
                <el-select class="w260" placeholder="工作类别" v-model="dbParms.dbgzlbid" clearable filterable @change="initDaiBan()">
                  <el-option v-for="item in gzlbData" :key="item.id" :label="item.gzlbmc" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item style="width: 200px;margin: 10px 10px 10px 0;">
                <el-input class="w260" placeholder="工作任务标题" v-model="dbParms.gzrwbt" clearable @clear="initDaiBan()" @keyup.enter="initDaiBan()">
                  <template #suffix>
                    <el-icon class="el-input__icon pointer" @click="initDaiBan()">
                      <search />
                    </el-icon>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item style="width: 200px;margin: 10px 10px 10px 0;">
                <el-input class="w260" placeholder="委派人" v-model="dbParms.wprxm" clearable @clear="initDaiBan()" @keyup.enter="initDaiBan()">
                  <template #suffix>
                    <el-icon class="el-input__icon pointer" @click="initDaiBan()">
                      <search />
                    </el-icon>
                  </template>
                </el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="mt20 mb10" style="display: flex;">
            <el-button v-if="xtszData.rcgz.sfxs" type="primary" plain round @click="openAddRiChang = true" style="height: 35px;"><span class="iconfont icon-chuangjian el-icon--left"></span>添加日常工作</el-button>
            <el-button v-if="xtszData.lsgz.sfxs" type="primary" plain round @click="lsgzAdd = true" style="height: 35px;"><span class="iconfont icon-chuangjian el-icon--left"></span>委派临时工作</el-button>
            <div class="button-box">
              <el-button type="success" plain round @click="daiBanActive = 'db'; initDaiBan()">待 办</el-button>
              <el-button type="success" plain round @click="daiBanActive = 'yb'; initDaiBan()">已 办</el-button>
              <el-button type="success" plain round @click="daiBanActive = 'hl'; initDaiBan()">忽 略</el-button>
              <el-button type="success" plain round @click="daiBanActive = 'yyj'; initDaiBan()" v-if="xtszData.yyj.sfxs">已 移 交</el-button>
              <el-button type="success" plain round @click="daiBanActive = 'ywp'; initDaiBan()" v-if="xtszData.ywp.sfxs">已 委 派</el-button>
              <el-button type="success" plain round @click="daiBanActive = 'jr'; initDaiBan()">今日工作</el-button>
              <el-button type="success" plain round @click="daiBanActive = 'bz'; initDaiBan()">本周工作</el-button>
              <el-button type="success" plain round @click="daiBanActive = 'by'; initDaiBan()">本月工作</el-button>
            </div>
          </div>
        </div>
        <div style="width:100%;">
          <el-table v-if="daiBanActive=='db' || daiBanActive=='yb' || daiBanActive=='hl' || daiBanActive=='yyj' || daiBanActive=='jr' || daiBanActive=='bz' || daiBanActive=='by'" :data="dbData" :default-sort="{ prop: dbParms.order, order: dbParms.sort }" v-loading="gzrwLading" @sort-change="dataGrid.sortChange" height="100%">
            <!-- 冻结列-Left BEGIN -->
            <el-table-column label="工作任务标题" prop="gzrwbt" align="center" xueshengxuexichengjishow-overflow-tooltip />
            <el-table-column label="工作类别" prop="dbgzlbmc" align="center" show-overflow-tooltip />
            <el-table-column label="完成时间" prop="wcsj" v-if="daiBanActive=='yb'" align="center" show-overflow-tooltip />
            <el-table-column label="要求完成时间" prop="yqwcsj" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                <span :style=" scope.row.zt == ztData.cswc ? 'color:#F56C6C' : ''"> {{ scope.row.yqwcsj }}</span>
              </template>
            </el-table-column>
            <el-table-column label="委派时间" prop="wpsj" align="center" show-overflow-tooltip />
            <el-table-column label="委派人" prop="wprxm" align="center" show-overflow-tooltip />
            <el-table-column v-if="daiBanActive == 'db' || daiBanActive == 'hl' || daiBanActive == 'jr' || daiBanActive == 'bz' || daiBanActive == 'by' " label="操作" align="center" width="180">
              <template #default="scope">
                <span v-if="scope.row.bgdbsx.id !== dbztData.jiaoxuerizhi && scope.row.bgdbsx.id !== dbztData.xunjian">
                  <el-button link type="primary" v-if="scope.row.bgdbsx.id == dbztData.zhibanrizhi" @click="openZhiBanRiZhi=true,row=scope.row">填报日志</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.zuzhishiwu" @click="openShiWuChuLi=true;row=scope.row">事务处理</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.kaoshijihuashijuanzujuan" @click="openShangChuanShiJuan=true;row=scope.row">上传试卷</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.kaoshijihuashijuanzujuanshenpi" @click="openShenPiShiJuan=true;row=scope.row">审核</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.tiaoke" @click="openTiaoKe=true,row=scope.row">办理</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.jiaoxuegongzuojiancha" @click="openJiaoXueJianCha=true,row={ jxgzjcjlid: scope.row.dbgzid }">检查</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.daike" @click="openDaiKe=true,row=scope.row">办理</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.linshigongzuo" @click="openWanChengLinShi=true,row=scope.row">完成</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.gudinggongzuo" @click="openWanChengGuDing=true,row=scope.row">完成</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.richanggongzuo" @click="openWanChengRiChang=true,row=scope.row">完成</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.jiaoxuesheji" @click="openJiaoXueSheJi=true,row={ id: scope.row.dbgzid }">上传</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.buzhizuoye" @click="openBuZhiZuoYe=true, row={ id: scope.row.dbgzid }">布置作业</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.xueqijiaoxuejihua" @click="openJiaoXueJiHua=true, row=scope.row">教学计划</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.pigaizuoye" @click="openPiGaiZuoYe=true;row={ id: scope.row.dbgzid }">批改</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.kejian" @click="openKeJian=true;row={ id: scope.row.dbgzid }">上传课件</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.guizhangzhiduyuedu" @click="openGuiZhangZhiDuYueDu=true;row={ id: scope.row.dbgzid }">阅读</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.weituixueshengsuguan" @click="openWeiGuiXueShengSuGuan=true;row={ id: scope.row.dbgzid }">查看</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.weiguixueshengbanzhuren" @click="openWeiGuiXueShengBanZhuRen=true;row={ id: scope.row.dbgzid }">查看</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.huiyiguanli" @click="openHuiYiGuanLi=true;row={ id: scope.row.dbgzid }">查看</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.kaohexiangmukaoheren" @click="openKaoHeXiangMuKaoHeRen=true;row={ id: scope.row.dbgzid }">查看</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.kaohexiangmupingjiaren" @click="openKaoHeXiangMuPingJiaRen=true;row={ id: scope.row.dbgzid }">评价</el-button>
                  <el-button link type="primary" v-else @click="isSPXQ = true; SPXQObj = { title: '详情', id: scope.row.dbgzid, lx: daiBanActive }">办理</el-button>
                  <el-button link type="primary" v-if="daiBanActive !== 'hl'" @click="hulueClick(scope.row)">忽略</el-button>
                </span>
                <span v-if="scope.row.bgdbsx.id == dbztData.jiaoxuerizhi">
                  <el-button link type="primary" @click="openJiaoXueRiZhi = true, row = { id: scope.row.dbgzid }">提交</el-button>
                  <el-button link type="primary" v-if="daiBanActive !== 'hl'" @click="hulueClick(scope.row)">忽略</el-button>
                </span>
              </template>
            </el-table-column>
            <el-table-column v-if="daiBanActive == 'yb'" label="操作" align="center" width="180">
              <template #default="scope">
                <span v-if="scope.row.bgdbsx.id !== dbztData.jiaoxuerizhi">
                  <!-- <el-button link type="primary" v-if="scope.row.bgdbsx.id == dbztData.zhibanrizhi" @click="openZhiBanRiZhiDetail=true,row=scope.row">详情</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.zuzhishiwu" @click="openShiWuChuLiDetail=true;row=scope.row">详情</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.kaoshijihuashijuanzujuan" @click="openShangChuanShiJuanDetail=true;row=scope.row">详情</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.kaoshijihuashijuanzujuanshenpi" @click="openShenPiShiJuanDetail=true;row=scope.row">详情</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.tiaoke" @click="openTiaoKeDetail=true,row=scope.row">详情</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.jiaoxuegongzuojiancha" @click="openJiaoXueJianCha=true,row={ jxgzjcjlid: scope.row.dbgzid }">详情</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.daike" @click="openDaiKeDetail=true,row=scope.row">详情</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.linshigongzuo" @click="openWanChengLinShiDetail=true,row=scope.row">详情</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.gudinggongzuo" @click="openWanChengGuDingDetail=true,row=scope.row">详情</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.richanggongzuo" @click="openWanChengRiChangDetail=true,row=scope.row">详情</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.jiaoxuesheji" @click="openJiaoXueSheJiDetail=true,row={ id: scope.row.dbgzid }">详情</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.buzhizuoye" @click="openBuZhiZuoYeDetail=true, row={ id: scope.row.dbgzid }">详情</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.xueqijiaoxuejihua" @click="openJiaoXueJiHuaDetail=true, row={dbgzid: scope.row.dbgzid}">详情</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.pigaizuoye" @click="openPiGaiZuoYeDetail=true;row={ id: scope.row.dbgzid }">详情</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.kejian" @click="openKeJianDetail=true;row={ id: scope.row.dbgzid }">详情</el-button> -->
                  <el-button link type="primary" v-if="scope.row.bgdbsx.id == dbztData.guizhangzhiduyuedu" @click="openGuiZhangZhiDuYueDu=true;row={ id: scope.row.dbgzid }">阅读</el-button>
                  <el-button link type="primary" v-if="scope.row.bgdbsx.id == dbztData.weituixueshengsuguan" @click="openWeiGuiXueShengSuGuan=true;row={ id: scope.row.dbgzid }">查看</el-button>
                  <el-button link type="primary" v-if="scope.row.bgdbsx.id == dbztData.weiguixueshengbanzhuren" @click="openWeiGuiXueShengBanZhuRen=true;row={ id: scope.row.dbgzid }">查看</el-button>
                  <el-button link type="primary" v-if="scope.row.bgdbsx.id == dbztData.huiyiguanli" @click="openHuiYiGuanLi=true;row={ id: scope.row.dbgzid, dbzt: ztData.ywc }">查看</el-button>
                  <el-button link type="primary" v-if="scope.row.bgdbsx.id == dbztData.xunjian" @click="openXunJianDetail=true;row={ id: scope.row.dbgzid }">详情</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.kaohexiangmukaoheren" @click="openKaoHeXiangMuKaoHeRen=true;row={ id: scope.row.dbgzid }">查看</el-button>
                  <el-button link type="primary" v-else-if="scope.row.bgdbsx.id == dbztData.kaohexiangmupingjiaren" @click="openKaoHeXiangMuPingJiaRenDetail=true;row={ id: scope.row.dbgzid }">查看</el-button>
                  <!-- <el-button link type="primary" v-else @click="isSPXQDetail = true; SPXQObj = { title: '详情', id: scope.row.dbgzid, lx: daiBanActive }">详情</el-button> -->
                </span>
                <!-- <span v-if="scope.row.bgdbsx.id == dbztData.jiaoxuerizhi">
                  <el-button link type="primary" @click="openJiaoXueRiZhiDetail = true, row = { id: scope.row.dbgzid }">详情</el-button>
                </span> -->
              </template>
            </el-table-column>
            <!-- 冻结列-Left END -->
          </el-table>

          <!-- 委派临时任务BEGIN -->
          <el-table v-if="daiBanActive == 'ywp'" :data="dbData" :default-sort="{ prop: dbParms.order, order: dbParms.sort }" v-loading="gzrwLading" @sort-change="dataGrid.sortChange" height="100%">
            <el-table-column label="工作任务标题" prop="gzrwbt" align="center" show-overflow-tooltip />
            <el-table-column label="要求完成时间" prop="yqwcsj" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                <span :style="scope.row.isDydqrq === true || scope.row.zt == ztData.cswc ? 'color:#F56C6C' : ''"> {{ scope.row.yqwcsj }}</span>
              </template>
            </el-table-column>
            <el-table-column label="部门" prop="bmmc" align="center" width="160" show-overflow-tooltip />
            <el-table-column label="负责人" prop="fzrxm" align="center" width="160" show-overflow-tooltip />
            <el-table-column label="移交人" prop="wprxm" align="center" show-overflow-tooltip />
            <el-table-column label="移交时间" prop="wpsj" align="center" show-overflow-tooltip />
            <el-table-column label="操作" align="center" width="180">
              <template #default="scope">
                <el-button link type="success" @click="openWeiPaiDetail=true; row=scope.row">详情</el-button>
                <!-- <el-button link type="primary" v-if="scope.row.zt==ztData.dwc || scope.row.zt==ztData.yhl" @click="openEditYwp=true; row=scope.row">修改</el-button>
                <el-button link type="warning" v-if="scope.row.zt==ztData.dwc || scope.row.zt==ztData.yhl" @click="dbDataGrid.multipleSelection=[scope.row.id]; weipaidel()">删除</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="mt10 wp100">
          <pagination :pagination="paginationObj" @ReturnData="initDaiBan" />
        </div>
      </div>
      <!-- 系统菜单 -->
      <div class="xitongcaidan">
        <div style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
          <div class="tit">
            <span>系统菜单</span>
            <div class="xian"></div>
          </div>
          <el-button circle @click="showXitongCaidan = !showXitongCaidan">
            <span class="iconfont" :class="showXitongCaidan ? 'icon-xiajiantou' : 'icon-shangjiantou'"></span>
          </el-button>
        </div>
        <!-- 内容列表 -->
        <el-card shadow="never" class="wp100 mb10" v-show="showXitongCaidan">
          <ul class="biaoqian">
            <li class="pointer" v-for="(item, index) in zxtData" :key="index" @click="handleClickspan(item)">
              <div class="mk-item">
                <div class="mk-icon-box" style="width: 60px; height: 60px;">
                  <span v-if="item.tb" :class="['mk-icon', 'iconfont', 'icon-' + item.tb]" style="font-size: 3em;"></span>
                  <span v-else class="mk-icon iconfont icon-morenmokuai" style="font-size: 3em;"></span>
                </div>
                <span class="mk-name">{{ item.cdmc }}</span>
              </div>
            </li>
          </ul>
        </el-card>
      </div>
      <div class="changguigognzuo">
        <div style="width: 100%;display: flex;justify-content: space-between;align-items: center;">
          <div class="tit">
            <span>常规工作</span>
            <div class="xian"></div>
          </div>
          <div>
            <el-input class="w300 mr10" placeholder="搜索功能模块" v-model="mkmc" style="" clearable @clear="showChangGuiGongZuo = true;initZhiWu();initZiXiTongQuanXian()" @keyup.enter="showChangGuiGongZuo = true;initZhiWu();initZiXiTongQuanXian()">
              <template #suffix>
                <el-icon class="el-input__icon pointer" @click="showChangGuiGongZuo = true;initZhiWu();initZiXiTongQuanXian()">
                  <search />
                </el-icon>
              </template>
            </el-input>
            <el-button circle @click="showChangGuiGongZuo = !showChangGuiGongZuo">
              <span class="iconfont" :class="showChangGuiGongZuo ? 'icon-xiajiantou' : 'icon-shangjiantou'"></span>
            </el-button>
          </div>
        </div>
        <!-- 内容列表 -->
        <el-card shadow="never" class="wp100" v-if="cggzData.length && showChangGuiGongZuo">
          <el-scrollbar height="100%">
            <el-descriptions :column="2" border>
              <el-descriptions-item width="140px" :span="2" label-align="center" v-for="(item, index) in cggzData" :key="index" :label="item.zwmc">
                <ul class="biaoqian">
                  <li class="mokuai" v-for="i in item.moudleQxs" :key="i.moudleid" @click="openTc = i.mklj">
                    <el-badge v-if="i.mklj === 'shenpibanli' || i.mklj === 'gognwen'" class="item">
                      <div class="mk-item">
                        <div class="mk-icon-box">
                          <span v-if="i.tb" :class="['mk-icon', 'iconfont', 'icon-' + i.tb]"></span>
                          <span v-else class="mk-icon iconfont icon-morenmokuai"></span>
                        </div>
                        <span class="mk-name">{{ i.mkmc }}</span>
                      </div>
                    </el-badge>
                    <div class="mk-item" v-else>
                      <div class="mk-icon-box">
                        <span v-if="i.tb" :class="['mk-icon', 'iconfont', 'icon-' + i.tb]"></span>
                        <span v-else class="mk-icon iconfont icon-morenmokuai"></span>
                      </div>
                      <span class="mk-name">{{ i.mkmc }}</span>
                    </div>
                  </li>
                </ul>
              </el-descriptions-item>
            </el-descriptions>
          </el-scrollbar>
        </el-card>
      </div>

      <el-row class="ml10 mr10 mb20" :gutter="20">
        <el-col :span="8">
          <div class="tit">
            <div style="display: flex;align-items: center;justify-content: space-between;">
              <span>备忘录</span>
              <div>
                <el-link class="mr10" type="primary" :underline="false" @click="openBeiWangLuAdd=true">
                  <el-icon :size="17" style="font-size: 17px;transform: rotate(45deg);-webkit-transform: rotate(45deg);">
                    <CloseBold />
                  </el-icon>
                </el-link>
                <el-link type="primary" :underline="false" @click="openBeiWangLu=true">
                  <el-icon style="font-size: 20px;"><Memo /></el-icon>
                </el-link>
              </div>
            </div>
            <div class="xian"></div>
          </div>
          <div class="tongzhi h440">
            <el-table :data="bwlData" height="100%" style="width: 100%;">
              <el-table-column prop="bt" label="标题" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span style="color: #409EFF;cursor: pointer;" @click="openBeiWangLuDetail = true;; row = scope.row">{{ scope.row.bt }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="lx" label="类型" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span v-for="(item,index) in bwllxData" :key="index">
                    <span v-if="scope.row.lx==item.value">{{ item.name }}</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="cjsj" label="创建时间" align="center" show-overflow-tooltip />
              <el-table-column label="操作" align="center">
                <template #default="scope">
                  <span style="color: #409EFF;cursor: pointer;" @click="openBeiWangLuEdit = true; row = scope.row">修改</span>
                  <span style="color: #ffac40;cursor: pointer;margin-left :4px;" @click="delBeiWangLu(scope.row)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="tit">
            <div style="display: flex;align-items: center;justify-content: space-between;">
              <span>资料汇编</span>
              <el-link type="primary" :underline="false" @click="openTc='ziliaohuibian'">
                <el-icon><Memo /></el-icon>
              </el-link>
            </div>
            <div class="xian"></div>
          </div>
          <div class="tongzhi h440">
            <el-table :data="zlhbData" height="100%" style="width: 100%;">
              <el-table-column prop="bt" label="资料名称" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span style="color: #409EFF;cursor: pointer;" @click="openZlDetail=true; row = scope.row">{{ scope.row.bt }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="jgmc" label="发布机构" align="center" show-overflow-tooltip />
              <el-table-column prop="fbsj" label="发布时间" align="center" show-overflow-tooltip />
            </el-table>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="tit">
            <div style="display: flex;align-items: center;justify-content: space-between;">
              <span>值班信息</span>
              <!-- 1-办公值班 -->
              <div v-if="xtszData.zbxx.cdlx===1">
                <el-link class="mr10" :type="zhiBanActive==='wdzb'?'primary':'info'" :underline="false" @click="zhiBanActive='wdzb';initWdzb()">我的值班</el-link>
                <el-link class="mr10" :type="zhiBanActive==='zbxx'?'primary':'info'" :underline="false" @click="zhiBanActive='zbxx';initZbxx()">当前值班信息</el-link>
                <el-link class="mr10" :type="zhiBanActive==='zbb'?'primary':'info'" :underline="false" @click="zhiBanActive='zbb';initZbb()">值班表</el-link>
                <el-link type="primary" :underline="false" @click="openTc='zhibanxinxi'">
                  <el-icon><Memo /></el-icon>
                </el-link>
              </div>
              <!-- 2-宿舍值班 -->
              <div v-if="xtszData.zbxx.cdlx===2">
                  <el-link class="mr10" :type="zhiBanActive==='wdzb'?'primary':'info'" :underline="false" @click="zhiBanActive='wdzb';initWdzbSs()">我的值班</el-link>
                  <el-link class="mr10" :type="zhiBanActive==='zbxx'?'primary':'info'" :underline="false" @click="zhiBanActive='zbxx';initWdzbSsDq()">当前值班信息</el-link>
                <el-link type="primary" :underline="false" @click="openTc='sushezhiban'">
                  <el-icon><Memo /></el-icon>
                </el-link>
              </div>
            </div>
            <div class="xian"></div>
          </div>
          <div class="tongzhi">
            <!-- 1-办公值班 -->
            <div class="h440" v-if="xtszData.zbxx.cdlx===1">
              <el-table v-if="zhiBanActive==='wdzb'" :data="wdzbTable" height="100%" style="width: 100%;">
                <el-table-column label="值班位置" prop="zbwz" align="center" show-overflow-tooltip />
                <el-table-column label="值班时段" prop="zbsd" width="90" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    <span v-for="(item, index) in zbsdData" :key="index">
                      <span v-if="scope.row.zbsd === item.value">{{item.name}}</span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="值班时间" prop="zbksrq" width="200" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    {{ scope.row.zbrq }}
                    {{ scope.row.zbkssj }}
                    <span v-if="scope.row.zbkssj && scope.row.zbjssj"> 至 </span>
                    {{ scope.row.zbjssj }}
                  </template>
                </el-table-column>
              </el-table>
              <el-table v-else-if="zhiBanActive==='zbxx'" :data="zbxxTable" height="100%" style="width: 100%;">
                <el-table-column label="值班内容" prop="zbnrmc" align="center" show-overflow-tooltip />
                <el-table-column label="值班人" prop="zbryxm" align="center" show-overflow-tooltip />
                <el-table-column v-if="zhiBanActive==='zbb'" label="值班日期" prop="zbrq" align="center" show-overflow-tooltip />
                <el-table-column label="值班位置" prop="zbwz" align="center" show-overflow-tooltip />
                <el-table-column label="值班时段" prop="zbsd" width="90" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    <span v-for="(item, index) in zbsdData" :key="index">
                      <span v-if="scope.row.zbsd === item.value">{{item.name}}</span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="值班时间" prop="zbsd" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    {{ scope.row.zbkssj }}<span v-if="scope.row.zbkssj && scope.row.zbjssj">-</span>{{ scope.row.zbjssj }}
                  </template>
                </el-table-column>
              </el-table>
              <el-table v-else-if="zhiBanActive==='zbb'" :data="zbbTable" height="100%" style="width: 100%;">
                <el-table-column label="值班类别" prop="zblbmc" align="center" show-overflow-tooltip />
                <el-table-column label="值班内容" prop="zbnrmc" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    <span style="color: #409EFF;cursor: pointer;" @click="openTc='zhibanbiao'; row=scope.row">{{scope.row.zbnrmc}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="值班时间" prop="zbksrq" width="200" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    {{ scope.row.zbksrq }}
                    <span v-if="scope.row.zbksrq && scope.row.zbjsrq"> 至 </span>
                    {{ scope.row.zbjsrq }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 2-宿舍值班 -->
            <div class="h440" v-if="xtszData.zbxx.cdlx===2">
              <el-table v-if="zhiBanActive==='wdzb'" :data="wdsszbTable" height="100%" style="width: 100%;">
                <el-table-column label="宿舍管理区域" prop="ssglqymc" align="center" show-overflow-tooltip />
                <el-table-column label="值班日期" prop="rq" align="center" show-overflow-tooltip />
                <el-table-column label="值班时间" prop="zbksrq" width="200" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    {{ scope.row.zbrq }}
                    {{ scope.row.zbkssj }}
                    <span v-if="scope.row.zbkssj && scope.row.zbjssj"> 至 </span>
                    <span v-if="scope.row.jssjlx==2">次日</span>
                    {{ scope.row.zbjssj }}
                  </template>
                </el-table-column>
              </el-table>
              <el-table v-else-if="zhiBanActive==='zbxx'" :data="sszbxxTable" height="100%" style="width: 100%;">
                <el-table-column label="宿舍管理区域" prop="ssglqymc" align="center" show-overflow-tooltip />
                <el-table-column label="值班时间" prop="zbksrq" width="200" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    {{ scope.row.zbrq }}
                    {{ scope.row.zbkssj }}
                    <span v-if="scope.row.zbkssj && scope.row.zbjssj"> 至 </span>
                    <span v-if="scope.row.jssjlx==2">次日</span>
                    {{ scope.row.zbjssj }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-scrollbar>
  </div>
  <!-- 待办事项 BEGIN -->
  <addrichang v-if="openAddRiChang" v-model:openAddRiChang="openAddRiChang" :row="row" @ReturnData="initDaiBan()" />
  <addlsgz v-if="lsgzAdd" v-model:lsgzAdd="lsgzAdd" :row="row" @ReturnData="initDaiBan()" />
  <shenpixiangqing v-if="isSPXQ" v-model:isSPXQ="isSPXQ" :SPXQObj="SPXQObj" @ReturnData="initDaiBan" />
  <zhibanrizhi v-if="openZhiBanRiZhi" v-model:openZhiBanRiZhi="openZhiBanRiZhi" :row="row" @ReturnData="initDaiBan()" />
  <zhibanrizhidetail v-if="openZhiBanRiZhiDetail" v-model:openZhiBanRiZhi="openZhiBanRiZhiDetail" :row="row" @ReturnData="initDaiBan()" />
  <shiwuchuli v-if="openShiWuChuLi" v-model:openShiWuChuLi="openShiWuChuLi" :row="row" @ReturnData="initDaiBan()" />
  <shiwuchulidetail v-if="openShiWuChuLiDetail" v-model:openDetail="openShiWuChuLiDetail" :row="row" @ReturnData="initDaiBan()" />
  <shangchuanshijuan v-if="openShangChuanShiJuan" v-model:openAdd="openShangChuanShiJuan" :row="row" @ReturnData="initDaiBan()" />
  <shangchuanshijuandetail v-if="openShangChuanShiJuanDetail" v-model:openAdd="openShangChuanShiJuanDetail" :row="row" @ReturnData="initDaiBan()" />
  <shenpishijuan v-if="openShenPiShiJuan" v-model:openShenPi="openShenPiShiJuan" :row="row" @ReturnData="initDaiBan()" />
  <shenpishijuandetail v-if="openShenPiShiJuanDetail" v-model:openShenPi="openShenPiShiJuanDetail" :row="row" @ReturnData="initDaiBan()" />
  <jiaoshitiaoke v-if="openTiaoKe" v-model:openTiaoKe="openTiaoKe" :row="row" @ReturnData="initDaiBan()" />
  <jiaoshitiaokedetail v-if="openTiaoKeDetail" v-model:openTiaoKe="openTiaoKeDetail" :row="row" @ReturnData="initDaiBan()" />
  <jiaoshijiaoxuejiancha v-if="openJiaoXueJianCha" v-model:openJiaoXueJianCha="openJiaoXueJianCha" :row="row" @ReturnData="initDaiBan()" />
  <jiaoshijiaoxuejianchadetail v-if="openJiaoXueJianChaDetail" v-model:openJiaoXueJianCha="openJiaoXueJianChaDetail" :row="row" @ReturnData="initDaiBan()" />
  <jiaoshidaike v-if="openDaiKe" v-model:openDaiKe="openDaiKe" :row="row" @ReturnData="initDaiBan()" />
  <wanchenglinshi v-if="openWanChengLinShi" v-model:openWanCheng="openWanChengLinShi" :row="row" @ReturnData="initDaiBan()" />
  <wanchenglinshidetail v-if="openWanChengLinShiDetail" v-model:openWanCheng="openWanChengLinShiDetail" :row="row" @ReturnData="initDaiBan()" />
  <wanchengguding v-if="openWanChengGuDing" v-model:openWanCheng="openWanChengGuDing" :row="row" @ReturnData="initDaiBan()" />
  <wanchenggudingdetail v-if="openWanChengGuDingDetail" v-model:openWanCheng="openWanChengGuDingDetail" :row="row" @ReturnData="initDaiBan()" />
  <wanchengrichang v-if="openWanChengRiChang" v-model:openWanCheng="openWanChengRiChang" :row="row" @ReturnData="initDaiBan()" />
  <wanchengrichangdetail v-if="openWanChengRiChangDetail" v-model:openWanCheng="openWanChengRiChangDetail" :row="row" @ReturnData="initDaiBan()" />
  <!-- <editywp v-if="openEditYwp" v-model:openEdit="openEditYwp" :row="row" @ReturnData="initDaiBan()" /> -->
  <weipaidetail v-if="openWeiPaiDetail" v-model:openWeiPaiDetail="openWeiPaiDetail" :row="row" @ReturnData="initDaiBan()" />
  <jiaoxueshejiadd v-if="openJiaoXueSheJi" v-model:openJiaoXueSheJi="openJiaoXueSheJi" :row="row" @ReturnData="initDaiBan()" />
  <jiaoxueshejidetail v-if="openJiaoXueSheJiDetail" v-model:openDetail="openJiaoXueSheJiDetail" :row="row" @ReturnData="initDaiBan()" />
  <addbuzhizuoye v-if="openBuZhiZuoYe" v-model:openBuZhiZuoYe="openBuZhiZuoYe" :row="row" @ReturnData="initDaiBan()" />
  <detailbuzhizuoye v-if="openBuZhiZuoYeDetail" v-model:openBuZhiZuoYe="openBuZhiZuoYeDetail" :row="row" @ReturnData="initDaiBan()" />
  <xueqijiaoxuejihua v-if="openJiaoXueJiHua" v-model:openJiaoXueJiHua="openJiaoXueJiHua" :row="row" @returnData="initDaiBan()" />
  <xueqijiaoxuejihuadetail v-if="openJiaoXueJiHuaDetail" v-model:openDetail="openJiaoXueJiHuaDetail" :row="row" @ReturnData="initDaiBan()" />
  <pigaizuoyelist v-if="openPiGaiZuoYe" v-model:openPiGaiList="openPiGaiZuoYe" :row="row" @ReturnData="initDaiBan()" />
  <shangchuankejian v-if="openKeJian" v-model:openKeJian="openKeJian" :row="row" @ReturnData="initDaiBan()" />
  <guizhangzhiduyuedu v-if="openGuiZhangZhiDuYueDu" v-model:openDetail="openGuiZhangZhiDuYueDu" :row="row" @ReturnData="initDaiBan()" />
  <jiaoshijiaoxuerizhi v-if="openJiaoXueRiZhi" v-model:openJiaoXueRiZhi="openJiaoXueRiZhi" :row="row" @ReturnData="initDaiBan()" />
  <susheweiguixuesheng v-if="openWeiGuiXueShengSuGuan" v-model:openList="openWeiGuiXueShengSuGuan" :row="row" @ReturnData="initDaiBan()" />
  <susheweiguixuesheng v-if="openWeiGuiXueShengBanZhuRen" v-model:openList="openWeiGuiXueShengBanZhuRen" :row="row" @ReturnData="initDaiBan()" />
  <huiyiguanli v-if="openHuiYiGuanLi" v-model:openList="openHuiYiGuanLi" :row="row" @ReturnData="initDaiBan()" />
  <kaohexiangmukaoheren v-if="openKaoHeXiangMuKaoHeRen" v-model:openList="openKaoHeXiangMuKaoHeRen" :row="row" @ReturnData="initDaiBan()" />
  <kaohexiangmupingjiaren v-if="openKaoHeXiangMuPingJiaRen" v-model:openList="openKaoHeXiangMuPingJiaRen" :row="row" @ReturnData="initDaiBan()" />
  <kaohexiangmupingjiarendetail v-if="openKaoHeXiangMuPingJiaRenDetail" v-model:openList="openKaoHeXiangMuPingJiaRenDetail" :row="row" @ReturnData="initDaiBan()" />
  <!-- 待办事项 END -->

  <!-- 常规工作/日常事务 开始 -->
  <!-- 通用 开始 -->
  <shenpizhongxin v-if="openTc === 'shenpibanli'" :open="openTc" @openReturn="openReturn" @ReturnData="initDaiBan();" />
  <qingjia v-if="openTc === 'qingjia'" :open="openTc" @openReturn="openReturn" @ReturnData="initDaiBan();" />
  <shenqing v-if="openTc === 'shenqing'" :open="openTc" @openReturn="openReturn" @ReturnData="initDaiBan();" />
  <wodegongzi v-if="openTc === 'wodegongzi'" :open="openTc" @openReturn="openReturn" />
  <wodezhiban v-if="openTc === 'wodezhiban'" :open="openTc" @openReturn="openReturn" />
  <zuzhishiwu v-if="openTc === 'zuzhishiwu'" :open="openTc" @openReturn="openReturn" />
  <zichanbaoxiu v-if="openTc === 'zichanbaoxiu'" :open="openTc" @openReturn="openReturn" />
  <zichanweixiu v-if="openTc === 'zichanweixiu'" :open="openTc" @openReturn="openReturn" />
  <anquanpeixunziliao v-if="openTc === 'anquanpeixunziliao'" :open="openTc" @openReturn="openReturn" />
  <yingjiyuan v-if="openTc === 'yingjiyuan'" :open="openTc" @openReturn="openReturn" />
  <wangpan v-if="openTc === 'wangpan'" :open="openTc" @openReturn="openReturn" />
  <yongyinshenqing v-if="openTc === 'yongyinshenqing'" :open="openTc" @openReturn="openReturn" />

  <!-- 办公室 -->
  <yongyinguanli v-if="openTc === 'yongyinguanli'" :open="openTc" :row="row" @openReturn="openReturn" />
  <zhizhangguanli v-if="openTc === 'zhizhangguanli'" :open="openTc" :row="row" @openReturn="openReturn" />

  <!-- 会计 -->
  <gongzibiao v-if="openTc === 'gongzibiao'" :open="openTc" :row="row" @openReturn="openReturn" />

  <!-- 出纳 -->
  <gongzifafang v-if="openTc === 'gongzifafang'" :open="openTc" :row="row" @openReturn="openReturn" />

  <!-- 班主任 -->
  <banzhurendaixuan v-if="openTc === 'banzhurendaixuan'" :open="openTc" @openReturn="openReturn" />
  <banjichengjichaxun v-if="openTc === 'banjichengjichaxun'" :open="openTc" @openReturn="openReturn" />
  <xuejiyidong v-if="openTc === 'xuejiyidong'" :open="openTc" @openReturn="openReturn" />
  <gebiejiaoyujilu v-if="openTc === 'gebiejiaoyujilu'" :open="openTc" @openReturn="openReturn" />
  <banganbuhuiyijilu v-if="openTc === 'banganbuhuiyijilu'" :open="openTc" @openReturn="openReturn" />
  <xueshengqingjia v-if="openTc === 'xueshengqingjia'" :open="openTc" @openReturn="openReturn" />
  <xueshengkaoqin v-if="openTc === 'xueshengkaoqin'" :open="openTc" @openReturn="openReturn" />
  <xuefenhuizong v-if="openTc === 'xuefenhuizong'" :open="openTc" @openReturn="openReturn" />
  <chaibanke v-if="openTc === 'chaibanke'" :open="openTc" @openReturn="openReturn" />
  <zonghesuzhipingjia v-if="openTc === 'zonghesuzhipingjiabanzhuren'" :open="openTc" @openReturn="openReturn" />

  <!-- 教师 -->
  <xueshenghuamingce v-if="openTc === 'xueshenghuamingce'" :open="openTc" @openReturn="openReturn" />
  <shitiku v-if="openTc === 'shitiku'" :open="openTc" :row="row" @openReturn="openReturn" />
  <gongwen v-if="openTc === 'gongwen'" :open="openTc" :row="row" @openReturn="openReturn" />
  <pigaizuoye v-if="openTc === 'pigaizuoye'" :open="openTc" :row="row" @openReturn="openReturn" />
  <zuoye v-if="openTc === 'zuoye'" :open="openTc" :row="row" @openReturn="openReturn" />
  <jiaoshixueqijiaoxuejihua v-if="openTc === 'xueqijiaoxuejihua'" :open="openTc" :row="row" @openReturn="openReturn" />
  <jiaoxuesheji v-if="openTc === 'jiaoxuesheji'" :open="openTc" :row="row" @openReturn="openReturn" />
  <tingkejilu v-if="openTc === 'tingkejilu'" :open="openTc" :row="row" @openReturn="openReturn" />
  <pingshichengjiluru v-if="openTc === 'pingshichengjiluru'" :open="openTc" :row="row" @openReturn="openReturn" />
  <kaoshichengjiluru v-if="openTc === 'kaoshichengjiluru'" :open="openTc" :row="row" @openReturn="openReturn" />
  <tiaodaike v-if="openTc === 'tiaodaike'" :open="openTc" :row="row" @openReturn="openReturn" />
  <wodekebiao v-if="openTc === 'wodekebiao'" :open="openTc" :row="row" @openReturn="openReturn" />
  <wodejiaoxuesheji v-if="openTc === 'wodejiaoxuesheji'" :open="openTc" :row="row" @openReturn="openReturn" />
  <wodebeike v-if="openTc === 'wodebeike'" :open="openTc" :row="row" @openReturn="openReturn" />
  <zonghesuzhipingjia v-if="openTc === 'zonghesuzhipingjiajiaoshi'" :open="openTc" :row="row" @openReturn="openReturn" />
  <wodewangluokecheng v-if="openTc === 'wodewangluokecheng'" :open="openTc" :row="row" @openReturn="openReturn" />
  <gongxiangwangluokecheng v-if="openTc === 'gongxiangwangluokecheng'" :open="openTc" :row="row" @openReturn="openReturn" />
  <wangluokechengxuexirenwu v-if="openTc === 'wangluokechengxuexirenwu'" :open="openTc" :row="row" @openReturn="openReturn" />
  <xueshengxuexijilu v-if="openTc === 'xueshengxuexijilu'" :open="openTc" :row="row" @openReturn="openReturn" />
  <xueshengceshijilu v-if="openTc === 'xueshengceshijilu'" :open="openTc" :row="row" @openReturn="openReturn" />
  <xueshengkaoshijilu v-if="openTc === 'xueshengkaoshijilu'" :open="openTc" :row="row" @openReturn="openReturn" />

  <!-- 其他-->
  <banjixiaolikebiao v-if="openTc === 'banjixiaolikebiao'" :open="openTc" :row="row" @openReturn="openReturn" />
  <chengjichaxun v-if="openTc === 'chengjichaxun'" :open="openTc" :row="row" @openReturn="openReturn" />
  <xueshengchengchu v-if="openTc === 'xueshengchengchu'" :open="openTc" :row="row" @openReturn="openReturn" />
  <xueshengjiangli v-if="openTc === 'xueshengjiangli'" :open="openTc" :row="row" @openReturn="openReturn" />
  <xunjianxiangqing v-if="openXunJianDetail" v-model:openDetail="openXunJianDetail" :row="row" />

  <!-- 常规工作/日常事务 结束 -->
  <!-- 评价列表：当前登录人id，本条id -->
  <!-- 备忘录 BEGIN -->
  <beiwanglu v-if="openBeiWangLu" v-model:openBeiWangLu="openBeiWangLu" :row="row" @ReturnData="initBeiWangLu()" />
  <beiwangluadd v-if="openBeiWangLuAdd" v-model:openAdd="openBeiWangLuAdd" :row="row" @ReturnData="initBeiWangLu()" />
  <beiwangluedit v-if="openBeiWangLuEdit" v-model:openEdit="openBeiWangLuEdit" :row="row" @ReturnData="initBeiWangLu()" />
  <beiwangludetail v-if="openBeiWangLuDetail" v-model:openDetail="openBeiWangLuDetail" :row="row" />
  <!-- 备忘录 END -->

  <!-- 通知公告 BEGIN -->
  <tongzhigonggao v-if="isTZGGGD" v-model:openList="isTZGGGD" :TZGGGDObj="TZGGGDObj" />
  <tongzhigonggaodetail v-if="isTZGGSEE" v-model:openDetail="isTZGGSEE" :row="row" />

  <tongzhigonggao v-if="isTZGGGD" v-model:isTZGGGD="isTZGGGD" />
  <tongzhigonggaodetail v-if="isTZGGSEE" v-model:isTZGGSEE="isTZGGSEE" :row="row" />
  <!-- 通知公告 END -->

  <!-- 资料汇编 BEGIN -->
  <ziliaohuibian v-if="openTc === 'ziliaohuibian'" :open="openTc" :row="row" @openReturn="openReturn" />
  <ziliaohuibiandetail v-if="openZlDetail" v-model:openDetail="openZlDetail" :row="row" />
  <!-- 资料汇编 END -->

  <!-- 值班信息 BEGIN -->
  <zhibanxinxi v-if="openTc === 'zhibanxinxi'" :open="openTc" :row="row" @openReturn="openReturn" />
  <zhibanbiao v-if="openTc === 'zhibanbiao'" :open="openTc" :row="row" @openReturn="openReturn" />
  <sushezhiban v-if="openTc === 'sushezhiban'" :open="openTc" :row="row" @openReturn="openReturn" />
  <!-- 值班信息 END -->

</template>

<script setup>
import { ref, watchEffect, defineEmits } from 'vue'
import { actionPost, loadSelect, submitDataGridAction } from '@/api/common.js'
import { getDate } from '@/utils/index.js'
import { getdbzt } from '@/utils/zidianmeiju'
import { successPrompt, warningPrompt } from '@/utils/promptInfo.js'
import pagination from '@/components/pagination.vue'
import tupian from '@/components/tupian.vue'

// 待办事项 开始
import addrichang from '@/components/home/daibanshixiang/tianjiagongzuo/addrichang.vue' // 添加日常
import addlsgz from '@/components/home/daibanshixiang/tianjiagongzuo/addlsgz.vue' // 添加临时工作
import shenpixiangqing from '@/components/home/changguishiwu/tongyong/shenpizhongxin/detail.vue' // 审批详情
import zhibanrizhi from '@/components/home/daibanshixiang/zhibanrizhi/list.vue' // 值班日志
import zhibanrizhidetail from '@/components/home/daibanshixiang/zhibanrizhi/detail.vue' // 值班日志详情
import shiwuchuli from '@/components/home/daibanshixiang/shiwuchuli/list.vue' // 事务处理
import shiwuchulidetail from '@/components/home/daibanshixiang/shiwuchuli/detail.vue' // 事务处理详情
import shangchuanshijuan from '@/components/home/daibanshixiang/zujuan/shangchuan.vue' // 组卷审批 上传试卷
import shangchuanshijuandetail from '@/components/home/daibanshixiang/zujuan/shangchuandetail.vue' // 组卷审批-上传试卷详情
import shenpishijuan from '@/components/home/daibanshixiang/zujuan/shenpishijuan.vue' // 组卷审批 审批试卷
import shenpishijuandetail from '@/components/home/daibanshixiang/zujuan/shenpishijuandetail.vue' // 组卷审批-审批试卷详情
import jiaoshitiaoke from '@/components/home/daibanshixiang/jiaoshitiaoke/list.vue' // 教师调课
import jiaoshitiaokedetail from '@/components/home/daibanshixiang/jiaoshitiaoke/detail.vue' // 教师调课详情
import jiaoshijiaoxuejiancha from '@/components/home/daibanshixiang/jiaoshijiaoxuejiancha/list.vue' // 教师教学检查
import jiaoshijiaoxuejianchadetail from '@/components/home/daibanshixiang/jiaoshijiaoxuejiancha/detail.vue' // 教师教学检查详情
import jiaoshidaike from '@/components/home/daibanshixiang/jiaoshidaike/list.vue' // 教师代课
import wanchenglinshi from '@/components/home/daibanshixiang/tianjiagongzuo/wanchenglinshi.vue' // 完成临时工作
import wanchenglinshidetail from '@/components/home/daibanshixiang/tianjiagongzuo/wanchenglinshidetail.vue' // 完成临时工作详情
import wanchengguding from '@/components/home/daibanshixiang/tianjiagongzuo/wancheng.vue' // 完成固定工作
import wanchenggudingdetail from '@/components/home/daibanshixiang/tianjiagongzuo/wanchengdetail.vue' // 完成固定工作详情
import wanchengrichang from '@/components/home/daibanshixiang/tianjiagongzuo/wanchengrichang.vue' // 完成日常工作
import wanchengrichangdetail from '@/components/home/daibanshixiang/tianjiagongzuo/wanchengrichangdetail.vue' // 完成日常工作详情
// import editywp from '@/components/home/daibanshixiang/tianjiagongzuo/edit.vue' // 修改工作
import weipaidetail from '@/components/home/daibanshixiang/tianjiagongzuo/detail.vue' // 委派详情
import jiaoxueshejiadd from '@/components/home/daibanshixiang/jiaoxuesheji/jiaoxueshejiadd.vue' // 教学设计添加
import jiaoxueshejidetail from '@/components/home/changguishiwu/jiaoshi/jiaoxuesheji/detailjiaoxuesheji.vue' // 教学设计详情
import addbuzhizuoye from '@/components/home/daibanshixiang/jiaoxuesheji/zuoyeadd.vue' // 布置作业添加
import detailbuzhizuoye from '@/components/home/daibanshixiang/jiaoxuesheji/zuoyedetail.vue' // 布置作业详情
import xueqijiaoxuejihua from '@/components/home/daibanshixiang/xueqijiaoxuejihua/list.vue' // 学期教学计划
import xueqijiaoxuejihuadetail from '@/components/home/daibanshixiang/xueqijiaoxuejihua/detail.vue' // 学期教学计划详情
import pigaizuoyelist from '@/components/home/daibanshixiang/pigaizuoye/pigailist.vue' // 批改作业列表
import shangchuankejian from '@/components/home/daibanshixiang/jiaoxuesheji/kejianadd.vue' // 上传课件
import guizhangzhiduyuedu from '@/components/guizhangzhidu/guizhangzhiduguanli/yuedu.vue' // 规章制度阅读
import jiaoshijiaoxuerizhi from '@/components/home/daibanshixiang/jiaoshijiaoxuerizhi/list.vue' // 教师教学日志
import susheweiguixuesheng from '@/components/home/daibanshixiang/susheweiguixuesheng/list.vue' // 宿舍未归学生
import huiyiguanli from '@/components/home/daibanshixiang/huiyiguanli/list.vue' // 会议管理
import kaohexiangmukaoheren from '@/components/home/daibanshixiang/jiaoshijiaoxuezhiliangkaohe/kaohe.vue' // 考核项目-考核人
import kaohexiangmupingjiaren from '@/components/home/daibanshixiang/jiaoshijiaoxuezhiliangkaohe/pingjia.vue' // 考核项目-评价人
import kaohexiangmupingjiarendetail from '@/components/home/daibanshixiang/jiaoshijiaoxuezhiliangkaohe/pingjiadetail.vue' // 考核项目-评价人
// 待办事项 结束

// 常规工作/日常事务 开始
import shenpizhongxin from '@/components/home/changguishiwu/tongyong/shenpizhongxin/list.vue' // 审批中心
import qingjia from '@/components/home/changguishiwu/tongyong/qingjia/list.vue' // 请假
import wodegongzi from '@/components/home/changguishiwu/tongyong/wodegongzi/list.vue' // 我的工资
import wodezhiban from '@/components/home/changguishiwu/tongyong/wodezhiban/list.vue' // 我的值班
import zuzhishiwu from '@/components/home/changguishiwu/tongyong/zuzhishiwu/list.vue' // 组织事务
import zichanbaoxiu from '@/components/home/changguishiwu/tongyong/zichanbaoxiu/list.vue' // 资产报修
import zichanweixiu from '@/components/home/changguishiwu/tongyong/zichanweixiu/list.vue' // 资产维修
import anquanpeixunziliao from '@/components/home/changguishiwu/tongyong/anquanpeixunziliao/list.vue' // 安全培训资料
import yingjiyuan from '@/components/home/changguishiwu/tongyong/yingjiyuan/list.vue' // 应急预案
import wangpan from '@/components/home/changguishiwu/tongyong/wangpan/list.vue' // 网盘
import yongyinshenqing from '@/components/home/changguishiwu/tongyong/yongyinshenqing/list.vue' // 用印

import shenqing from '@/components/home/changguishiwu/tongyong/shenqing/list.vue' // 申请
import gongzibiao from '@/components/home/kuaiji/gongzibiao/list.vue' // 工资表

// 办公室
import yongyinguanli from '@/components/home/bangongshi/yongyinguanli/list.vue' // 用印管理
import zhizhangguanli from '@/components/home/bangongshi/zhizhangguanli/list.vue' // 制章管理

// 出纳
import gongzifafang from '@/components/home/chuna/gongzifafang/list.vue' // 工资发放

// 班主任
import banzhurendaixuan from '@/components/home/changguishiwu/banzhuren/banzhurendaixuan/list.vue' // 班主任待选
import banjichengjichaxun from '@/components/home/changguishiwu/banzhuren/banjichengjichaxun/list.vue' // 班级成绩查询
import xuejiyidong from '@/components/home/changguishiwu/banzhuren/xuejiyidong/list.vue' // 学籍异动
import gebiejiaoyujilu from '@/components/home/changguishiwu/banzhuren/gebiejiaoyujilu/list.vue' // 个别教育记录
import banganbuhuiyijilu from '@/components/home/changguishiwu/banzhuren/banganbuhuiyijilu/list.vue' // 班干部会议记录
import xueshengqingjia from '@/components/home/changguishiwu/banzhuren/xueshengqingjia/list.vue' // 学生请假
import xueshengkaoqin from '@/components/home/changguishiwu/banzhuren/xueshengkaoqin/list.vue' // 学生考勤
import xuefenhuizong from '@/components/home/changguishiwu/banzhuren/xuefenhuizong/list.vue' // 学分汇总
import chaibanke from '@/components/home/changguishiwu/banzhuren/chaibanke/list.vue' // 拆班课

// 教师
import xueshenghuamingce from '@/components/home/xueshenghuamingce.vue' // 学生花名册
import shitiku from '@/components/home/changguishiwu/jiaoshi/shitiku/list.vue' // 试题库
import gongwen from '@/components/home/changguishiwu/jiaoshi/gongwen/list.vue' // 公文
import zuoye from '@/components/home/changguishiwu/jiaoshi/zuoye/list.vue' // 作业
import pigaizuoye from '@/components/home/changguishiwu/jiaoshi/pigaizuoye/list.vue' // 批改作业
import tiaodaike from '@/components/home/changguishiwu/jiaoshi/tiaodaike/list.vue' // 调代课
import jiaoshixueqijiaoxuejihua from '@/components/home/changguishiwu/jiaoshi/xueqijiaoxuejihua/list.vue' // 学期教学计划
import jiaoxuesheji from '@/components/home/changguishiwu/jiaoshi/jiaoxuesheji/list.vue' // 教学设计
import tingkejilu from '@/components/home/changguishiwu/jiaoshi/tingkejilu/list.vue' // 听课记录
import pingshichengjiluru from '@/components/home/changguishiwu/jiaoshi/pingshichengjiluru/list.vue' // 平时成绩录入
import kaoshichengjiluru from '@/components/home/changguishiwu/jiaoshi/kaoshichengjiluru/list.vue' // 考试成绩录入
import wodekebiao from '@/components/home/changguishiwu/jiaoshi/wodekebiao/list.vue' // 我的课表
import wodejiaoxuesheji from '@/components/home/changguishiwu/jiaoshi/wodejiaoxuesheji/list.vue' // 我的教学设计
import wodebeike from '@/components/home/changguishiwu/jiaoshi/wodebeike/list.vue' // 我的备课
import zonghesuzhipingjia from '@/components/home/changguishiwu/jiaoshi/zonghesuzhipingjia/list.vue' // 综合素质评价
import wodewangluokecheng from '@/components/home/changguishiwu/jiaoshi/wodewangluokecheng/list.vue' // 我的网络课程
import gongxiangwangluokecheng from '@/components/home/changguishiwu/jiaoshi/gongxiangwangluokecheng/list.vue' // 共享网络课程
import wangluokechengxuexirenwu from '@/components/home/changguishiwu/jiaoshi/wangluokechengxuexirenwu/list.vue' // 网络课程学习任务
import xueshengxuexijilu from '@/components/home/changguishiwu/jiaoshi/xueshengxuexijilu/list.vue' // 学生学习记录
import xueshengceshijilu from '@/components/home/changguishiwu/jiaoshi/xueshengceshijilu/list.vue' // 学生测试记录
import xueshengkaoshijilu from '@/components/home/changguishiwu/jiaoshi/xueshengkaoshijilu/list.vue' // 学生考试记录
import xueshengxuexichengji from '@/components/home/changguishiwu/jiaoshi/xueshengxuexichengji/list.vue' // 学生学习成绩

// 其他
import banjixiaolikebiao from '@/components/home/banjixiaolikebiao.vue' // 班级校历课表
import chengjichaxun from '@/components/home/chengjichaxun.vue' // 成绩查询
import xueshengchengchu from '@/components/home/xueshengchengchu/list.vue' // 学生惩处
import xueshengjiangli from '@/components/home/xueshengjiangli/list.vue' // 学生奖励
import xunjianxiangqing from '@/pages/pinganxiaoyuan/xunjianguanli/xunjianjilu/detail.vue' // 巡检详情

// 常规工作/日常事务 结束

// 通知公告 BEGIN
import tongzhigonggao from '@/components/home/tongzhigonggao/list.vue' // 通知公告
import tongzhigonggaodetail from '@/components/home/tongzhigonggao/detail.vue' // 通知公告详情
// 通知公告 END

// 备忘录 开始
import beiwanglu from '@/components/home/beiwanglu/list.vue' // 备忘录
import beiwangluadd from '@/pages/bangong/qita/beiwanglu/add.vue' // 备忘录添加
import beiwangluedit from '@/pages/bangong/qita/beiwanglu/edit.vue' // 备忘录修改
import beiwangludetail from '@/pages/bangong/qita/beiwanglu/detail.vue' // 备忘录详情
// 备忘录 结束

// 资料汇编 BEGIN
import ziliaohuibian from '@/components/home/ziliaohuibian.vue' // 资料汇编
import ziliaohuibiandetail from '@/pages/bangong/richangbangong/ziliaohuibian/detail.vue' // 资料汇编详情
// 资料汇编 END

// 值班信息 BEGIN
import zhibanxinxi from '@/components/home/zhibanxinxi/list.vue' // 值班表详情
import zhibanbiao from '@/components/home/zhibanxinxi/zhibanbiaodetail.vue' // 值班表详情
import sushezhiban from '@/components/home/sushezhiban/list.vue' // 值班表详情
// 值班信息 END

// 路由、vuex 开始
import { useRouter } from 'vue-router'
const router = useRouter()
// 路由、vuex 结束

const emits = defineEmits(['ReturnData'])

const baseUrl = ref(process.env.VUE_APP_BASE_API)
// 加载 轮播图
const lbtData = ref([])
loadSelect({
  url: '/api/v2/bangong/xitongshouyelunbotu/list',
  data: lbtData,
  order: 'sx',
  sort: 'asc'
})

// 工作任务 BEGIN
const ztData = ref({ listZhuangTai: [] })
loadSelect({
  url: '/api/v2/bangong/bangongdaibanshixiang/daibanzhuangtai',
  data: ztData,
  loadSuccess: function () {
    initDaiBan()
  }
})

// 待办事项 BEGIN
const openAddRiChang = ref(false) // 添加日常工作
const lsgzAdd = ref(false) // 委派临时工作
const isSPXQ = ref(false) // 审批详情
const openZhiBanRiZhi = ref(false) // 值班日志
const openZhiBanRiZhiDetail = ref(false) // 值班日志详情
const openShiWuChuLi = ref(false) // 事务处理
const openShiWuChuLiDetail = ref(false) // 事务处理详情
const openShangChuanShiJuan = ref(false) // 上传试卷
const openShangChuanShiJuanDetail = ref(false) // 上传试卷详情
const openShenPiShiJuan = ref(false) // 审批试卷
const openShenPiShiJuanDetail = ref(false) // 审批试卷详情
const openTiaoKe = ref(false) // 教师调课
const openTiaoKeDetail = ref(false) // 教师调课详情
const openJiaoXueJianCha = ref(false) // 教师教学检查
const openJiaoXueJianChaDetail = ref(false) // 教师教学检查详情
const openDaiKe = ref(false) // 教师代课
// const openDaiKeDetail = ref(false) // 教师代课详情
const openWanChengLinShi = ref(false) // 完成临时工作
const openWanChengLinShiDetail = ref(false) // 完成临时工作详情
const openWanChengGuDing = ref(false) // 完成固定工作
const openWanChengGuDingDetail = ref(false) // 完成固定工作详情
const openWanChengRiChang = ref(false) // 完成日常工作
const openWanChengRiChangDetail = ref(false) // 完成日常工作详情
const openJiaoXueSheJi = ref(false) // 添加教学设计
const openJiaoXueSheJiDetail = ref(false) // 添加教学设计详情
const openBuZhiZuoYe = ref(false) // 添加布置工作
const openBuZhiZuoYeDetail = ref(false) // 添加布置工作详情
const openJiaoXueJiHua = ref(false) // 学期教学计划
const openJiaoXueJiHuaDetail = ref(false) // 学期教学计划详情
const openPiGaiZuoYe = ref(false) // 批改作业列表
// const openPiGaiZuoYeDetail = ref(false) // 批改作业列表详情
const openGuiZhangZhiDuYueDu = ref(false) // 规章制度阅读
const openKeJian = ref(false) // 上传课件
// const openKeJianDetail = ref(false) // 上传课件详情
const openJiaoXueRiZhi = ref(false) // 教师教学日志
// const openJiaoXueRiZhiDetail = ref(false) // 教师教学日志详情
const openXunJianDetail = ref(false) // 巡检详情
const openWeiGuiXueShengSuGuan = ref(false) // 宿舍未归学生统计-宿管
const openWeiGuiXueShengBanZhuRen = ref(false) // 宿舍未归学生统计-班主任
const openHuiYiGuanLi = ref(false) // 会议管理
const openKaoHeXiangMuKaoHeRen = ref(false) // 考核项目-考核人
const openKaoHeXiangMuPingJiaRen = ref(false) // 考核项目-评价人
const openKaoHeXiangMuPingJiaRenDetail = ref(false) // 考核项目-评价人

// const openEditYwp = ref(false) // 修改已委派
const openWeiPaiDetail = ref(false) // 委派详情
// 待办事项 END

const isTZGGGD = ref(false) // 通知公告
const isTZGGSEE = ref(false) // 通知公告详情

const daiBanActive = ref('db')
const dbztData = ref(getdbzt()) // 待办状态
const paginationObj = ref({
  background: false,
  pageNo: 1,
  pageSize: 5,
  total: 0,
  layout: 'prev, pager, next, jumper, total'
})
const gzrwLading = ref(false)
const dbData = ref([]) // 待办
const dbParms = ref({}) // 待办搜索
const dbRqqj = ref([]) // 日期区间

const dataGrid = ref({
  sortChange: function (column) {
    dbParms.value.order = column.prop
    dbParms.value.sort = column.order
    initDaiBan()
  }
})
const initDaiBan = (pageNo, pageSize) => {
  dbData.value = []
  gzrwLading.value = true
  dbParms.value.ksyqwcsj = dbRqqj.value ? dbRqqj.value[0] : undefined
  dbParms.value.jsyqwcsj = dbRqqj.value ? dbRqqj.value[1] : undefined
  dbParms.value.dbgzlbid = dbParms.value.dbgzlbid || undefined
  dbParms.value.gzrwbt = dbParms.value.gzrwbt || undefined
  dbParms.value.order = dbParms.value.order || 'yqwcsj'
  dbParms.value.sort = dbParms.value.sort === 'ascending' ? 'asc' : 'desc'
  dbParms.value.pageNo = pageNo || 1
  dbParms.value.pageSize = pageSize || 5
  let url = ''
  switch (daiBanActive.value) {
    case 'db': // 待办
      dbParms.value.zt = ztData.value.dwc
      url = '/api/v2/bangong/bangongdaibanshixiang/ztlist'
      break
    case 'yb': // 已办
      dbParms.value.zt = ztData.value.ywc
      url = '/api/v2/bangong/bangongdaibanshixiang/ztlist'
      break
    case 'hl': // 忽略
      dbParms.value.zt = ztData.value.yhl
      url = '/api/v2/bangong/bangongdaibanshixiang/ztlist'
      break
    case 'yyj': // 已移交
      dbParms.value.zt = ztData.value.yyj
      url = '/api/v2/bangong/bangongdaibanshixiang/ztlist'
      break
    case 'ywp': // 已委派
      dbParms.value.zt = null
      url = '/api/v2/bangong/bangonglinshidaibanshixiang/list'
      break
    case 'jr': // 今日工作
      dbParms.value.zt = ztData.value.dwc
      url = '/api/v2/bangong/bangongdaibanshixiang/dangtiandaiban'
      break
    case 'bz': // 本周工作
      dbParms.value.zt = ztData.value.dwc
      url = '/api/v2/bangong/bangongdaibanshixiang/zhoudaiban'
      break
    case 'by': // 本月工作
      dbParms.value.zt = ztData.value.dwc
      url = '/api/v2/bangong/bangongdaibanshixiang/yuedaiban'
      break
  }
  actionPost({ url: url, data: dbParms.value }).then((res) => {
    if (res.code === 200) {
      const dqn = getDate('YYYY')
      const dqrq = getDate('YYYY', 'MM', 'DD', 'HH', 'mm')
      if (res.data.list) {
        res.data.list.forEach((element) => {
          element.isDydqrq = false
          if (element.yqwcsj) {
            const rq = element.yqwcsj.slice(0, 10)
            if (new Date(dqrq).getTime() > new Date(element.yqwcsj).getTime()) {
              element.isDydqrq = true
            }
            const nf = element.yqwcsj.slice(0, 4)
            // 当前年份去掉年
            if (dqn === nf) {
              element.yqwcsj = element.yqwcsj.slice(5, 16)
            }
            if (rq === '1970-01-01') {
              element.yqwcsj = element.yqwcsj.slice(11, 16)
            }
          }
        })
      }
      gzrwLading.value = false
      dbData.value = res.data.list // 返回列表
      paginationObj.value.pageNo = dbParms.value.pageNo
      paginationObj.value.pageSize = dbParms.value.pageSize
      paginationObj.value.total = res.data.total
      // handleCheckChange()
    } else {
      gzrwLading.value = false
      warningPrompt(res.message)
    }
  })
}
const gzlbData = ref([])
// 完整类别
// loadSelect({
//   url: '/api/v2/bangong/bangongdaibanshixiang/gongzuoleibie',
//   data: gzlbData,
//   order: 'gzlbmc',
//   sort: 'asc'
// })
// 包含类别
loadSelect({
  url: '/api/v2/bangong/bangongdaibanshixiang/dangqianyonghugongzuoleibie',
  data: gzlbData,
  order: 'gzlbmc',
  sort: 'asc'
})

const timer = ref(null)
const lunXun = () => {
  timer.value = setInterval(async () => {
    setTimeout(function () {
      initDaiBan()
    }, 600)
  }, 60000)
}
lunXun()
// 监听鼠标键盘事件
watchEffect(() => {
  document.addEventListener('keydown', () => {
    clearInterval(timer.value)
    lunXun()
  })
  document.addEventListener('mousewheel', () => {
    clearInterval(timer.value)
    lunXun()
  })
  document.addEventListener('mousedown', () => {
    clearInterval(timer.value)
    lunXun()
  })
})

// 待办事项 忽略
const hulueClick = (item) => {
  actionPost({
    url: '/api/v2/bangong/bangongdaibanshixiang/hulue',
    data: { id: item.id }
  }).then((res) => {
    if (res.code === 200) {
      initDaiBan()
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
// 工作任务 END

// 子系统 BEGIN
const showXitongCaidan = ref(false)
const zxtData = ref([])
const mkmc = ref('')
const initZiXiTongQuanXian = () => {
  actionPost({
    url: `/api/v2/sys/menu/shouyezixitonglist?cdmc=${mkmc.value}`,
    data: {}
  }).then((res) => {
    if (res.code === 200) {
      zxtData.value = res.data || []
    } else {
      warningPrompt(res.message)
    }
  })
}
initZiXiTongQuanXian()
// 菜单点击
const handleClickspan = (item) => {
  if (!item.zjlj) {
    window.open(item.cdlj, '_blank')
    window.open('/', '_self')
  } else {
    window.open(item.cdlj, '_parent')
  }
}
// 子系统 END

// 职务 BEGIN
const activeYeWu = ref(1)
const cggzData = ref([])
const showChangGuiGongZuo = ref(false)
const initZhiWu = async () => {
  actionPost({
    url: '/api/v2/account/getCurrentUserZw',
    data: { mc: mkmc.value }
  }).then((res) => {
    if (res.code === 200) {
      if (xtszData.value.zwty.sfxs === false) {
        res.data.forEach((element, index) => {
          if (element.id === null) {
            res.data.splice(index, 1)
          }
        })
      }
      cggzData.value = res.data
      activeYeWu.value = res.data ? res.data[0].zwid : ''
    } else {
      warningPrompt(res.message)
    }
  })
}
const openTc = ref('') // 打开弹窗
const openReturn = (val) => {
  openTc.value = val // 关闭弹窗或关闭后打开新弹窗
}
// 职务 END

// 备忘录 BEGIN

// 备忘录类型 BEGIN
const bwllxData = ref([])
loadSelect({
  url: '/api/v2/bangong/beiwanglu/beiwangluleixing',
  data: bwllxData
})

const openBeiWangLu = ref(false)
const openBeiWangLuAdd = ref(false)
const openBeiWangLuEdit = ref(false)
const openBeiWangLuDetail = ref(false)
const bwlData = ref([])
const initBeiWangLu = () => {
  actionPost({
    url: '/api/v2/bangong/beiwanglu/pagelist',
    data: { order: 'cjsj', sort: 'desc', pageNo: 1, pageSize: 10 }
  }).then((res) => {
    if (res.code === 200) {
      res.data.list.forEach((element) => {
        element.cjsj = element.cjsj.substring(5, 16)
      })
      bwlData.value = res.data.list
    } else {
      warningPrompt(res.message)
    }
  })
}
initBeiWangLu()
// 删除备忘录
const delBeiWangLu = async (item) => {
  const dataGrid = { multipleSelection: [item.id] }
  submitDataGridAction({
    url: '/api/v2/bangong/beiwanglu',
    dataGrid: dataGrid,
    confirmTitle: '确定要删除吗?',
    method: 'delete',
    callback: function () {
      initBeiWangLu()
    }
  })
}
// 备忘录 END

// 资料汇编 BEGIN
const openZlDetail = ref(false)
const zlhbData = ref([])
const initZLHBList = () => {
  actionPost({
    url: '/api/v2/bangong/ziliaohuibian/shenhetongguopagelist',
    data: { order: 'fbsj', sort: 'desc', pageNo: 1, pageSize: 10 }
  }).then((res) => {
    if (res.code === 200) {
      res.data.list.forEach((element) => {
        element.fbsj = element.fbsj.substring(5, 16)
      })
      zlhbData.value = res.data.list
    } else {
      warningPrompt(res.message)
    }
  })
}
initZLHBList()
// 资料汇编 END

// 通知公告 BEGIN
const tzggLading = ref(false)
const tzggData = ref([])
const GongGaoActive = ref(0)
// 通知公告分类（下标即接口所需的 gglx）
const tzggTabs = [
  { label: '全部', value: 0 },
  { label: '学校', value: 1 },
  { label: '部门', value: 2 }
]
const initTongZhiGongGao = () => {
  tzggData.value = []
  tzggLading.value = true
  actionPost({
    url: '/api/v2/bangong/tongzhigonggao/shouye/pagelist',
    data: {
      order: 'fbsj',
      sort: 'desc',
      pageNo: 1,
      pageSize: 5,
      gglx: GongGaoActive.value || undefined
    }
  }).then((res) => {
    tzggLading.value = false
    if (res.code === 200) {
      res.data.list.forEach((element) => {
        element.fbsj = element.fbsj ? element.fbsj.substring(5, 16) : ''
      })
      tzggData.value = res.data.list
    } else {
      warningPrompt(res.message)
    }
  })
}
initTongZhiGongGao()
// 通知公告 END

// 值班信息 BEGIN
// 加载 值班时段 下拉框
const zbsdData = ref([])
loadSelect({
  url: '/api/v2/bangong/zhibanneirong/zhibanshiduan',
  data: zbsdData
})
const zhiBanActive = ref('wdzb') // 值班选中
const wdsszbTable = ref([])
// 我的宿舍值班
const initWdzbSs = () => {
  wdsszbTable.value = []
  const data = { order: 'zbkssj', sort: 'asc', pageNo: 1, pageSize: 10 }
  actionPost({
    url: '/api/v2/sushe/sushezhibanbiao/dangtianpagelist',
    data: data
  }).then((res) => {
    if (res.code === 200) {
      wdsszbTable.value = res.data.list || []
    } else {
      warningPrompt(res.message)
    }
  })
}
initWdzbSs()
// 我的宿舍当前值班
const sszbxxTable = ref([])
const initWdzbSsDq = () => {
  sszbxxTable.value = []
  const data = { pageNo: 1, pageSize: 10 }
  actionPost({
    url: '/api/v2/sushe/sushezhibanbiao/wodezhibanpagelist',
    data: data
  }).then((res) => {
    if (res.code === 200) {
      sszbxxTable.value = res.data.list || []
    } else {
      warningPrompt(res.message)
    }
  })
}
// 我的值班
const wdzbTable = ref([])
const initWdzb = () => {
  wdzbTable.value = []
  const data = { order: 'zbrq', sort: 'desc', pageNo: 1, pageSize: 10 }
  actionPost({
    url: '/api/v2/bangong/zhibanrenyuanjilu/dangqianyonghupagelist',
    data: data
  }).then((res) => {
    if (res.code === 200) {
      wdzbTable.value = res.data.list || []
    } else {
      warningPrompt(res.message)
    }
  })
}
initWdzb()
// 当前值班信息
const zbxxTable = ref([])
const initZbxx = async () => {
  zbxxTable.value = []
  const data = {
    zbkssj: getDate(null, null, null, 'HH', 'mm'),
    order: 'zbkssj',
    sort: 'desc',
    pageNo: 1,
    pageSize: 10
  }
  actionPost({
    url: '/api/v2/bangong/zhibanrenyuanjilu/zhibanjiludantian',
    data: data
  }).then((res) => {
    if (res.code === 200) {
      zbxxTable.value = res.data.list || []
    } else {
      warningPrompt(res.message)
    }
  })
}
// 值班表
const zbbTable = ref([])
const initZbb = async () => {
  zbbTable.value = []
  const data = { order: 'zbnrmc', sort: 'asc', pageNo: 1, pageSize: 10 }
  actionPost({
    url: '/api/v2/bangong/zhibanrenwu/pagelist',
    data: data
  }).then((res) => {
    if (res.code === 200) {
      zbbTable.value = res.data.list || []
    } else {
      warningPrompt(res.message)
    }
  })
}
// 值班信息 END

// 系统设置 BEGIN
const xtszData = ref({ grzx: {}, lsgz: {}, rcgz: {}, ywp: {}, yyj: {}, xtjs: {}, xqgl: {}, zbxx: {}, zcd: {}, zwty: {} })
const initXiTongSheZhi = () => {
  setTimeout(function () {
    xtszData.value = JSON.parse(sessionStorage.getItem('XITONGSHEZHI'))
  }, 600)
  initZhiWu()
}
initXiTongSheZhi()
// 系统设置 END
</script>

<style lang="less" scoped>
@import '@/assets/css/home.less';
</style>
<style>
/* 媒体：宽度小于 1440px 像素则修改样式 */
@media screen and (max-width: 1440px) {
  .biaoqian li {
    width: 16% !important;
  }
  .biaoqian .mokuai {
    width: 19% !important;
  }
}
</style>
